/* eslint-disable react/jsx-key */
import React from 'react';
import { useTable, usePagination, useSortBy, useExpanded } from 'react-table';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import ChildTable from './ChildTable';
import arrowIcon from '../../assets/images/svg/right.svg';
import upArrow from '../../assets/images/svg/sort-up.svg';
import downArrow from '../../assets/images/svg/sort-down.svg';
import bothArrow from '../../assets/images/svg/sort-both.svg';

const initialState = {
  queryPageIndex: 0
};
const PAGE_CHANGED = 'PAGE_CHANGED';
const reducer = (state, { type, payload }) => {
  switch (type) {
    case PAGE_CHANGED:
      return {
        ...state,
        queryPageIndex: payload
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
};
function TNTable({
  columns,
  data,
  paginationData,
  t,
  onSelectPage,
  idName = '',
  pageIndexGet = 0,
  childColumns = [],
  customWidth
}) {
  initialState.queryPageIndex = pageIndexGet;
  const [{ queryPageIndex }, dispatch] = React.useReducer(reducer, initialState);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    // Get the state from the instance
    state: { pageIndex },
    rows
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageIndex: queryPageIndex
      },
      autoResetFilters: false,
      manualPagination: true, // Tell the usePagination
      // hook that we'll handle our own data fetching
      // This means we'll also have to provide our own
      // pageCount.
      pageCount: paginationData.last_page
    },
    useSortBy,
    useExpanded,
    usePagination
  );
  React.useEffect(() => {
    onSelectPage(pageIndex);
    dispatch({ type: PAGE_CHANGED, payload: pageIndex });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);
  const firstPageRows = rows.slice(0, 21);

  return (
    <>
      <div className="table-responsive" style={{ width: `${customWidth}px` }}>
        <Table
          {...getTableProps()}
          className="text-center table-sortable mt-3 m-0 data-table"
          id={idName}>
          <thead className="align-middle">
            {headerGroups.map((headerGroup, index) => (
              <tr key={index}>
                {headerGroup.headers.map((column, sindex) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())} key={sindex}>
                    {column.render('Header')}
                    <span>
                      {column.canSort && (
                        <img
                          src={`admin/${
                            column.isSorted
                              ? column.isSortedDesc
                                ? downArrow
                                : upArrow
                              : bothArrow
                          }`}
                          alt="sort arrow"
                        />
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()} className={firstPageRows.length === 0 ? 'd-none' : ''}>
            {firstPageRows.map((row, inx) => {
              prepareRow(row);
              return (
                <React.Fragment key={inx}>
                  <tr {...row.getRowProps()} key={inx}>
                    {row.cells.map((cell, cellIndex) => {
                      return (
                        <td {...cell.getCellProps()} key={cellIndex}>
                          {cell.render('Cell')}
                        </td>
                      );
                    })}
                  </tr>
                  {row.isExpanded ? (
                    <tr key={`${inx}-expanded`}>
                      <td colSpan={columns.length}>
                        <ChildTable columns={childColumns} data={row.original.tableColumns} t={t} />
                      </td>
                    </tr>
                  ) : null}
                </React.Fragment>
              );
            })}
          </tbody>
          <tbody {...getTableBodyProps()} className={firstPageRows.length === 0 ? '' : 'd-none'}>
            <tr>
              <td colSpan={columns.length} style={{ textAlign: 'center' }}>
                {paginationData?.no_record_text
                  ? paginationData?.no_record_text
                  : t('page.no_data_found_table')}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div className="paginationTable">
        <Row className={firstPageRows.length === 0 ? 'd-none' : ''}>
          <Col lg={12} xs={12}>
            <div className="tablePagination">
              <div className="d-flex align-items-center">
                <button
                  onClick={() => gotoPage(0)}
                  disabled={!canPreviousPage}
                  className="control-btn control-first">
                  {'<<'}
                </button>
                <button
                  onClick={() => previousPage()}
                  disabled={!canPreviousPage}
                  className="control-btn prev">
                  <img src={`admin/${arrowIcon}`} />
                  {/* {'<'} */}
                </button>
                <span className="old-page-numbers">
                  Page{' '}
                  <strong>
                    {pageIndex + 1} of {pageOptions.length}
                  </strong>{' '}
                </span>
                {/* New Page number */}
                <span className="page-numbers">
                  <strong>{pageIndex + 1}</strong>/{pageOptions.length}
                </span>
                <button
                  onClick={() => nextPage()}
                  disabled={!canNextPage}
                  className="control-btn next">
                  <img src={`admin/${arrowIcon}`} />
                </button>
                <button
                  onClick={() => gotoPage(pageCount - 1)}
                  disabled={!canNextPage}
                  className="control-btn control-last">
                  {'>>'}
                </button>
              </div>
              <span className="total-result">
                {paginationData.count} of {paginationData.total}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
TNTable.propTypes = {
  columns: PropTypes.any,
  paginationData: PropTypes.any,
  data: PropTypes.any,
  pageIndexGet: PropTypes.any,
  t: PropTypes.func,
  idName: PropTypes.string,
  onSelectPage: PropTypes.func,
  customclass: PropTypes.any
};
export default TNTable;
